module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"section":{"title":"事業所一覧"}}}')
  delete Component.options._Ctor
}
